import Decimal from 'decimal.js-light';
import { useCallback } from 'react';
import { CurrencyInput, CurrencyInputProps } from './CurrencyInput';

export interface DecimalInputProps
  extends Omit<CurrencyInputProps, 'currency'> {
  asNumber?: boolean;
}

/**
 * Campo per input di tipo Decimal che non sono valute, ad esempio
 * numeri con la virgola come la quantità.
 */
export function DecimalInput(props: DecimalInputProps) {
  const { asNumber, ...otherProps } = props;

  const transformValueToNumber = useCallback(
    (parsedValue: Decimal | string | number | null) =>
      parsedValue instanceof Decimal
        ? parsedValue.toNumber()
        : typeof parsedValue === 'string' && parsedValue !== ''
        ? Number(parsedValue)
        : parsedValue,
    [],
  );

  return (
    <CurrencyInput
      {...otherProps}
      hideCurrency
      transformValue={asNumber ? transformValueToNumber : null}
    />
  );
}
